export const SliceConstants = {
  GetAllCatalogs: 'getAllCatalogs',
  GetAllSubCatalogs: 'getAllSubCatalogs',
  GetCatalog: 'getCatalog',
};
